export const { BOT_ID } = process.env;
export const HOST_API = process.env.NEXT_PUBLIC_HOST_API;
export const BASIC_URL_FOR_IMAGES = `${HOST_API}/upload/`;

export const TOGGLER_NAMES = {
  isManagementDialog: 'isManagementDialog',
  isAddEventDialog: 'isAddEventDialog',
  isGreetingSendDataModal: 'isGreetingSendDataModal',
};
